<template>
  <div class="bar-menu">
    <el-menu
      :default-active="activeMark"
      @select="goToPage"
      class="vertical-menu">
      <el-menu-item
        v-for="(item, index) in menuArr"
        :key="index"
        :index="item.dataMark">
        <i :class="item.icon"></i>
        <span
          slot="title"
          :title="$t(`lang.${item.name}`)">{{ $t(`lang.${item.name}`) }}</span>
      </el-menu-item>
    </el-menu>
    <el-badge
      :value="messageNum"
      class="messageBox"
      :hidden="!messageNum">
      <span
        class="iconfont icon-a-mail2"
        :title="$t('lang.TAlert')"
        @click.stop="goToPage('al')"></span>
    </el-badge>
  </div>
</template>
<script>
// Source/Receiver 家族路由在菜单上共用 hm 项高亮
// TODO: optimize-router-architecture 的 meta.menuGroup 落地后改由路由 meta 读取
const HM_GROUP = ['hm', 'mr', 'rc', 'tm', 'hmn']
// 菜单入口不做前端权限拦截的页面，由路由守卫和后端裁决
const PERMISSION_EXEMPT = ['al', 'rps', 'tm']
// 无权限提示文案映射，未命中回退 menuNoPermission
const NO_PERMISSION_TIPS = {
  mv: 'mvNoPermission',
  tkm: 'tkNoPermission'
}
export default {
  props: {
    menuArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    messageNum () {
      return this.$store.state.messageNum
    },
    activeMark () {
      const path = this.$route.path.split('/')[1]
      return HM_GROUP.includes(path) ? 'hm' : path
    }
  },
  methods: {
    goToPage (dataMark) {
      const item = this.menuArr.find(v => v.dataMark == dataMark)
      if (item && item.permission || PERMISSION_EXEMPT.includes(dataMark)) {
        this.$router.push({ path: `/${dataMark}` }).catch(() => {})
      } else {
        this.$message({
          type: 'info',
          message: this.$t(`lang.${NO_PERMISSION_TIPS[dataMark] || 'menuNoPermission'}`)
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bar-menu {
  width: 64px;
  height: 100%;
  float: left;
  .vertical-menu {
    width: 64px;
    height: 100%;
    border-right: none;
    background: #333;
    color: #dbdbdb;
    .el-menu-item {
      padding: 0!important;
      line-height: 0!important;
      height: 62px;
      color: #666;
      margin-bottom: 5px;
      .iconfont {
        font-size: 24px;
        line-height: 45px;
      }
      span {
        display: block;
        width: 100%;
        overflow: hidden;
        height: 20px;
        line-height: 20px;
        margin-top: -8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 2px;
      }
      &.is-active {
        color: #dbdbdb;
        background: none;
      }
      &:hover {
        color: #dbdbdb;
        background: none!important;
        .iconfont {
          color: #dbdbdb;
        }
      }
    }
  }
  .messageBox {
    position: absolute;
    left: 15px;
    bottom: 15px;
    z-index: 100000;
    .icon-a-mail2 {
      color: #666;
      font-size: 24px;
      cursor: pointer;
      &:hover {
        color: #DBDBDB;
      }
    }
  }
}
</style>
